import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24" }
const _hoisted_14 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24" }
const _hoisted_25 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_departamento = _resolveComponent("selecionar-departamento")!
  const _component_selecionar_funcao = _resolveComponent("selecionar-funcao")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_selecionar_unidade = _resolveComponent("selecionar-unidade")!
  const _component_comissao_categoria = _resolveComponent("comissao-categoria")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    key: _ctx.computedColaborador.codigo,
    titulo: "DADOS DO COLABORADOR"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_form_item, {
            label: "Usuário",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_usuario, {
                empresas: _ctx.props.empresas,
                codigoSelecionado: _ctx.computedColaborador.codigoUsuario,
                "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedColaborador.codigoUsuario) = $event))
              }, null, 8, ["empresas", "codigoSelecionado"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_form_item, {
            label: "Departamento",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_departamento, {
                varios: true,
                "codigos-selecionados": _ctx.computedDepartamentos,
                "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedDepartamentos) = $event)),
                empresas: _ctx.props.empresas
              }, null, 8, ["codigos-selecionados", "empresas"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_form_item, {
            label: "Função",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_funcao, {
                varios: true,
                "codigos-selecionados": _ctx.computedFuncoes,
                "onUpdate:codigosSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedFuncoes) = $event)),
                empresas: _ctx.props.empresas
              }, null, 8, ["codigos-selecionados", "empresas"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_form_item, {
            label: "Comissão",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                percentual: true,
                "quantidade-casas-decimais": 2,
                valor: _ctx.computedColaborador.comissao.percentualComissao,
                "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedColaborador.comissao.percentualComissao) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_form_item, {
            label: "Taxa Decréscimo",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                percentual: true,
                "quantidade-casas-decimais": 2,
                valor: _ctx.computedColaborador.comissao.taxaDecrescimo,
                "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedColaborador.comissao.taxaDecrescimo) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_a_tabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "Participantes da Comissão"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_form_item, {
                    label: "Colaborador",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_colaborador, {
                        "codigo-selecionado": _ctx.state.participante.codigoColaborador,
                        "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.participante.codigoColaborador) = $event)),
                        "descricao-selecionado": _ctx.state.participante.nomeColaborador,
                        "onUpdate:descricaoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.participante.nomeColaborador) = $event)),
                        empresas: _ctx.props.empresas
                      }, null, 8, ["codigo-selecionado", "descricao-selecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_form_item, {
                    label: "Comissão",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        percentual: true,
                        "quantidade-casas-decimais": 2,
                        valor: _ctx.state.participante.percentualComissao,
                        "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.participante.percentualComissao) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, {
                    label: " ",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "ant-btn ant-btn-primary",
                        style: {"width":"100%"},
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.inserirParticipante && _ctx.inserirParticipante(...args)))
                      }, _toDisplayString(_ctx.state.indexParticipante === -1 ? 'Adicionar' : 'Editar'), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.computedColaborador.comissao.participantes.length > 0)
                    ? (_openBlock(), _createBlock(_component_a_table, {
                        key: 0,
                        columns: _ctx.state.colunasParticipantes.filter(item => item.visible),
                        "data-source": _ctx.computedColaborador.comissao.participantes,
                        rowKey: "codigo",
                        pagination: false,
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, index, text }) => [
                          (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.editarParticipante(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "editar" })
                                ], 8, _hoisted_15),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.excluirParticipante(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          (column.customRenderRow === _ctx.ECustomRenderRow.MascararPorcentagem)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2) + '%'), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"]))
                    : (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                        key: 1,
                        mensagem: "Nenhum participante adicionado."
                      }))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "Comissão por Unidade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_a_form_item, {
                    label: "Unidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_unidade, {
                        "codigo-selecionado": _ctx.state.unidade.codigoUnidade,
                        "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.unidade.codigoUnidade) = $event)),
                        "descricao-selecionado": _ctx.state.unidade.descricaoUnidade,
                        "onUpdate:descricaoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.unidade.descricaoUnidade) = $event)),
                        empresas: _ctx.props.empresas
                      }, null, 8, ["codigo-selecionado", "descricao-selecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_a_form_item, {
                    label: "Participante",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_colaborador, {
                        "codigo-selecionado": _ctx.state.unidade.codigoParticipante,
                        "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.unidade.codigoParticipante) = $event)),
                        "descricao-selecionado": _ctx.state.unidade.nomeParticipante,
                        "onUpdate:descricaoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.unidade.nomeParticipante) = $event)),
                        empresas: _ctx.props.empresas
                      }, null, 8, ["codigo-selecionado", "descricao-selecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_a_form_item, {
                    label: "Comissão",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        monetario: true,
                        "quantidade-casas-decimais": 2,
                        valor: _ctx.state.unidade.valorComissao,
                        "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.unidade.valorComissao) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_a_form_item, {
                    label: " ",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "ant-btn ant-btn-primary",
                        style: {"width":"100%"},
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.inserirUnidade && _ctx.inserirUnidade(...args)))
                      }, _toDisplayString(_ctx.state.indexUnidade === -1 ? 'Adicionar' : 'Editar'), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.computedColaborador.comissao.unidades.length > 0)
                    ? (_openBlock(), _createBlock(_component_a_table, {
                        key: 0,
                        columns: _ctx.state.colunasUnidades.filter(item => item.visible),
                        "data-source": _ctx.computedColaborador.comissao.unidades,
                        rowKey: "codigo",
                        pagination: false,
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, index, text }) => [
                          (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.editarUnidade(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "editar" })
                                ], 8, _hoisted_26),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.excluirUnidade(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_27)
                              ]))
                            : _createCommentVNode("", true),
                          (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString('R$' + _ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"]))
                    : (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                        key: 1,
                        mensagem: "Nenhuma unidade adicionada."
                      }))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "3",
            tab: "Comissão por Categoria e Produtos",
            style: {"max-height":"150px","overflow":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_comissao_categoria, { categorias: _ctx.computedComissoesCategorias }, null, 8, ["categorias"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}